import Slider from 'react-slick';
import Image from 'next/image';
import { setCarouselConfig } from '../../../utils/carousel';

export default function MusicCarousel({ config, content }) {
    const settings = setCarouselConfig(config, 'music');

    return (
        <div className={`oCarouselMusic`}>
            <Slider {...settings}>
                {content.map((carouselItem) => (
                    <div key={carouselItem.id} className={`oCard MusicCard`}>
                        <div className={`cardWrapper`}>
                            <div className={`oCardImage`}>
                                <figure className={`mImage`}>
                                    <Image
                                        src={carouselItem.image.data.attributes.url}
                                        alt={``}
                                        width={carouselItem.image.data.attributes.width}
                                        height={carouselItem.image.data.attributes.height}
                                        className={`aImage`}
                                        aria-hidden="true"
                                        layout="responsive"
                                    />
                                </figure>
                            </div>
                            <div className={`oCardBody`}>
                                <p className={`aTitle fnt-xb fnt13f`}>{carouselItem.title}</p>
                                <p className={`aText fnt-sb fnt12f`}>
                                    {carouselItem.duration_songs}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
            <style global jsx>{`
                .oCarouselMusic {
                    max-width: 580px;
                }
                .slick-slider {
                    max-width: 1920px;
                    margin: 0 auto;
                    overflow: hidden;
                }
                .oCarouselMusic .slick-track {
                    overflow: auto;
                    display: flex !important;
                }
                .oCarouselMusic .slick-slide {
                    transform: scale(0.9);
                    transition: 0.3s;
                    display: block;
                    height: auto;
                }
                .oCarouselMusic .slick-slide > div {
                    height: 100%;
                }
                .slick-slide.slick-center {
                    transform: scale(1);
                    transition: 0.3s;
                }
                .slick-slider button {
                    position: absolute;
                }
                .oCarouselMusic .slick-dots {
                    list-style-type: none;
                    padding: 0;
                    margin: 0 0 0 12px;
                    display: block;
                    text-align: center;
                }
                .slick-dots li {
                    display: inline-block;
                    background-color: #dfe1e2;
                    width: 10px;
                    height: 10px;
                    border-radius: 10px;
                    margin-right: 5px;
                }
                .slick-dots li:last-child {
                    margin-right: 0;
                }
                .oCarouselMusic .slick-dots li.slick-active {
                    background-color: #b058f3;
                }
                .slick-dots li button {
                    opacity: 0;
                }
                .slick-arrow {
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 10;
                    border: 0;
                    background-color: transparent;
                    text-indent: 400px;
                    overflow: hidden;
                    width: 50px;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                .slick-arrow.slick-next {
                    right: 2%;
                    background-image: url('./images/icon-arrow-right.svg');
                }
                .slick-arrow.slick-prev {
                    left: 2%;
                    background-image: url('./images/icon-arrow-left.svg');
                }
            `}</style>
        </div>
    );
}
